import { type FieldError } from 'react-hook-form';
import { cn } from '@bedrock/ui/utils';

type ErrorMessageProps = Readonly<{
  error?: FieldError;
  className?: string;
}>;

export function ErrorMessage({ error, className }: ErrorMessageProps) {
  if (!error) {
    return null;
  }

  return <span className={cn('text-destructive mt-0.5 text-sm', className)}>{error.message}</span>;
}
